import { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { audioManager, SoundType } from '../utils/audio';

interface SoundContextType {
  soundEnabled: boolean;
  toggleSound: () => void;
  playSound: (type: SoundType) => void;
}

const SoundContext = createContext<SoundContextType | undefined>(undefined);

export function SoundProvider({ children }: { children: ReactNode }) {
  const [soundEnabled, setSoundEnabled] = useState(audioManager.isEnabled());

  const toggleSound = useCallback(() => {
    const newState = !soundEnabled;
    audioManager.setEnabled(newState);
    setSoundEnabled(newState);
  }, [soundEnabled]);

  const playSound = useCallback((type: SoundType) => {
    audioManager.play(type);
  }, []);

  return (
    <SoundContext.Provider value={{ soundEnabled, toggleSound, playSound }}>
      {children}
    </SoundContext.Provider>
  );
}

export function useSound() {
  const context = useContext(SoundContext);
  if (context === undefined) {
    throw new Error('useSound must be used within a SoundProvider');
  }
  return context;
}
